/* September Collections — Scroll reveal
   Les sections sous l'écran apparaissent en fondu quand on y arrive.
   (Rien de tout ça quand l'appareil demande moins d'animations.) */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Seuil à 0 plutôt qu'en pourcentage : une section plus haute que l'écran
  // (la grille de produits sur téléphone) n'est jamais visible à 12 % et
  // restait masquée pour de bon.
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -60px 0px' }
  );

  document.querySelectorAll(
    '#MainContent > .shopify-section:not(:first-child)'
  ).forEach(function (section) {
    // Le script passe après le premier affichage : masquer une section déjà à
    // l'écran la faisait disparaître puis revenir.
    if (section.getBoundingClientRect().top < window.innerHeight) return;
    // Les produits d'une collection ou d'une recherche ne dépendent pas d'une animation.
    if (section.querySelector('results-list')) return;
    section.classList.add('sc-reveal');
    observer.observe(section);
  });
})();

/* Guide des tailles — déplace le lien dans le legend du variant-picker */
(function () {
  var guideBlock = document.querySelector('[class*="size_guide_link"]');
  var legend = document.querySelector('.product-information .variant-option legend');
  if (!guideBlock || !legend) return;
  var link = guideBlock.querySelector('a');
  if (!link) return;
  link.classList.add('sc-size-guide');
  legend.appendChild(link);
})();

/* Mega-menu — injecte les images des collections */
(function () {
  // Les vignettes suivent le menu « Collection » de l'admin Shopify
  // (Contenu > Menus > Menu principal) : une vignette par lien vers une
  // collection, dans l'ordre du menu, avec le titre saisi dans le menu.
  // Ajouter, renommer ou retirer une catégorie se fait donc dans le menu,
  // sans toucher à ce fichier. « Toute la collection » n'a pas de vignette.
  function collectionsDuMenu(grid) {
    var collections = [];
    grid.querySelectorAll('.mega-menu__link').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      // « Pour Elle » : lien vers mllecabestan.fr, photo = accueil mlle (scripts/image-pour-elle.js).
      if (/^https?:\/\/(www\.)?mllecabestan\.fr/i.test(href)) {
        if (grid.dataset.imagePourElle) collections.push({ href: href, image: grid.dataset.imagePourElle, title: link.textContent.trim() });
        return;
      }
      var m = href.match(/\/collections\/([^\/?#]+)/);
      if (!m || m[1] === 'all') return;
      collections.push({ handle: m[1], title: link.textContent.trim() });
    });
    return collections;
  }

  function injectImages(grid) {
    if (grid.querySelector('.sc-mega-images')) return;
    var collections = collectionsDuMenu(grid);
    if (collections.length === 0) return;

    var container = document.createElement('div');
    container.className = 'sc-mega-images';
    container.style.gridTemplateColumns = 'repeat(' + collections.length + ', minmax(0, 1fr))';

    collections.forEach(function (col) {
      var card = document.createElement('a');
      card.href = col.href || '/collections/' + col.handle;
      var cadre = document.createElement('div');
      cadre.className = 'sc-mega-img';
      var img = document.createElement('img');
      img.alt = col.title;
      img.loading = 'lazy';
      cadre.appendChild(img);
      var titre = document.createElement('p');
      titre.className = 'sc-mega-title';
      titre.textContent = col.title;
      card.appendChild(cadre);
      card.appendChild(titre);
      container.appendChild(card);

      if (col.image) { img.src = col.image; return; }
      // L'image est celle de la collection dans l'admin Shopify.
      fetch('/collections/' + col.handle + '.json')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.collection && data.collection.image) {
            var src = data.collection.image.src;
            img.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=400';
          }
        })
        .catch(function () {});
    });

    grid.appendChild(container);
  }

  // Observe mega-menu apparition
  var observer = new MutationObserver(function () {
    var grids = document.querySelectorAll('.mega-menu__grid');
    grids.forEach(function (grid) {
      if (!grid.querySelector('.sc-mega-images')) {
        injectImages(grid);
      }
    });
  });

  var header = document.querySelector('header-component, header');
  if (header) {
    observer.observe(header, { childList: true, subtree: true, attributes: true });
  }

  // Also run once on load in case mega-menu is already in DOM
  document.querySelectorAll('.mega-menu__grid').forEach(injectImages);
})();

/* Header — toggle .sc-menu-open quand un sous-menu est ouvert */
(function () {
  var hc = document.querySelector('header-component');
  if (!hc) return;

  var observer = new MutationObserver(function () {
    var expanded = hc.querySelector('.menu-list__link[aria-expanded="true"]');
    if (expanded) {
      hc.classList.add('sc-menu-open');
    } else {
      hc.classList.remove('sc-menu-open');
    }
  });

  observer.observe(hc, { attributes: true, subtree: true, attributeFilter: ['aria-expanded'] });
})();

/* Liens externes — ouverts dans un nouvel onglet, pour ne pas faire quitter le site */
(function () {
  // Le compte client et le paiement sont hébergés par Shopify : ils font partie
  // du parcours d'achat et restent dans l'onglet.
  var shopify = /(^|\.)(shopify\.com|myshopify\.com|shop\.app)$/;

  // Au clic plutôt qu'au chargement : le menu et les tiroirs ajoutent des liens après coup.
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href]') : null;
    if (!link || link.target) return;
    if (link.protocol !== 'http:' && link.protocol !== 'https:') return;
    var host = link.hostname.replace(/^www\./, '');
    if (host === window.location.hostname.replace(/^www\./, '') || shopify.test(host)) return;
    link.target = '_blank';
    link.rel = 'noopener';
  }, true);
})();

/* Page « Collection » — ajoute la carte « Pour Elle » (photo de l'accueil mlle) à la grille des catégories */
(function () {
  // Même source que le menu : le lien « Pour Elle » du menu principal et la photo
  // copiée par scripts/image-pour-elle.js. Rien à saisir dans la page elle-même.
  function ajouter() {
    var grille = document.querySelector('.section-resource-list [data-testid="collections-list-grid"]');
    if (!grille || grille.querySelector('[data-pour-elle]')) return;
    // Le menu d'ordinateur et le tiroir mobile sont tous deux dans la page : on prend ce qui est là.
    var menu = document.querySelector('.mega-menu__grid[data-image-pour-elle]');
    var photo = menu ? menu.dataset.imagePourElle : null;
    var lien = null;
    document.querySelectorAll('.mega-menu__link, .menu-drawer__menu-item').forEach(function (a) {
      if (!lien && /^https?:\/\/(www\.)?mllecabestan\.fr/i.test(a.getAttribute('href') || '')) lien = a;
    });
    var modele = grille.querySelector('.resource-list__item:last-child');
    if (!photo || !lien || !modele) return;

    var carte = modele.cloneNode(true);
    carte.setAttribute('data-pour-elle', '');
    var titre = lien.textContent.trim();
    var a = carte.querySelector('.collection-card__link');
    a.href = lien.getAttribute('href');
    a.target = '_blank';
    a.rel = 'noopener';
    var cache = a.querySelector('.visually-hidden');
    if (cache) cache.textContent = titre;
    var img = carte.querySelector('.collection-card__image img');
    if (img) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = photo;
      img.alt = titre;
    }
    var p = carte.querySelector('.collection-card__content p');
    if (p) p.textContent = titre;
    grille.appendChild(carte);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ajouter);
  else ajouter();
  // Au cas où la grille arrive après coup (navigation sans rechargement).
  new MutationObserver(ajouter).observe(document.body, { childList: true, subtree: true });
})();
